/* global Promise */
import angular from 'angular';
import * as R from 'ramda';

export default function BulkApproveImpactAnalysisDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkApprove = _handleBulkApprove;

  vm.handleSelectProcessChange = _handleSelectProcessChange;
  vm.handleSelectAll = _handleSelectAll;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.approveableProcesses = [];
    angular.forEach(vm.processes, (process) => {
      if (process && process.impactAnalysis && (process.impactAnalysis.submitted === true)
          && (process.impactAnalysis.approved !== true)) {
        vm.approveableProcesses.push(process);
      }
    });

    if (vm.processes.length > 0) {
      vm.hasData = true;
    }
    
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.bulkApproveImpactAnalysisDialog);
  }

  function _handleSelectProcessChange() {
    const selectedIds = [];

    R.forEach((item) => {
      if (item.isSelected === true) {
        selectedIds.push(item.processId);
      }
    }, vm.processes);

    vm.approveIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.processes.length;
  }
  
  function _handleSelectAll() {
    R.forEach((item) => {
      item.isSelected = vm.selectAll;
    }, vm.processes);
      
    vm.approveIsSelected = vm.selectAll;
  } 

  function _handleBulkApprove() {
    loaderService.showViewLoader = true;
    const bulkApproveProcessIds = [];
    // Find selections
    angular.forEach(vm.processes, (process) => {
      if (process && process.isSelected) {
        bulkApproveProcessIds.push(process.assessmentProcessId);
      }
    });
    // Stop if no selections
    if (bulkApproveProcessIds.length <= 0) {
      vm.isSelected = false;
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }
    // Reset selected
    return bcpDataService.bulkApproveAssessmentProcesses(vm.assessmentId, bulkApproveProcessIds).then(() => {
      alerts.success('The Business Impact Analysis Processes have been Approved successfully.');
      _handleCloseDialog();
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshBCPAssessments');
    },
    () => {
      alerts.error('The Business Impact Analysis Processes have failed to reset.');
      loaderService.showViewLoader = false;
    });
  }
}

BulkApproveImpactAnalysisDialogController.$inject = [
  '$rootScope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
